// extracted by mini-css-extract-plugin
export var toggled = "PlusIcon-module--toggled--3b200";
export var wrapper = "PlusIcon-module--wrapper--7b307";